
import GwContentTemplate from '~/patterns/templates/content.vue';
import seo from '~/mixins/seo';
import getTrainerPage from '~/graphql/queries/getTrainerPage.graphql';
import GwPageTitle from '~/patterns/molecules/page-title/page-title';
import GwPageSubtitle from '~/patterns/molecules/page-subtitle/page-subtitle';
import GwPageContainer from '~/patterns/molecules/page-container/page-container';
import FlexibleSection from '~/patterns/organisms/_flexible-section/flexible-section';
import GwError from '~/patterns/molecules/error';

export default {
    components: {
        GwContentTemplate,
        GwPageContainer,
        GwPageTitle,
        GwPageSubtitle,
        GwError,
        FlexibleSection,
    },
    mixins: [seo],
    data() {
        return {
            entry: null,
        };
    },
    async fetch() {
        const site = this.$config.appMultisiteHandle,
            uri = this.$route.path.replace(/^\/|\/$/, ''),
            { data } = await this.$gql.executeQuery(
                getTrainerPage,
                { site, uri }
            );

        if (data && data.entry) {
            this.entry = data.entry;
        } else {
            this.notFound = true;
            if (process.server) {
                this.$nuxt.context.res.statusCode = 404;
            }
        }
    },
    nuxtI18n: {
        paths: {
            en: '/trainers/:slug',
            in: '/trainers/:slug',
            nl: '/trainers/:slug',
            fr: '/formateurs/:slug',
            de: '/trainer/:slug',
            'en-Highberg': '/trainers/:slug',
            'nl-Highberg': '/trainers/:slug',
            'de-Highberg': '/trainer/:slug',
        }
    }
};
